export default __webpack_public_path__ + "static/partnerIcon17-15b4540cc4e96be9d75881cc4758e31b.svg";